import React from "react";
import classNames from "classnames";
import { FilterIcon } from "@icons";
import { Button } from "@design-system/Button/Button";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@design-system/Popover/Popover";
import styles from "./AggregatedFilters.module.scss";
import { useAggregatedFiltersContext } from "./AggregatedFilters.context";

interface Props {
    className?: string;
    children: React.ReactNode;
    disabled?: boolean;
    label?: React.ReactNode;
    portalContainer?: HTMLElement;
}

export const AggregatedFilters: React.FC<Props> = ({
    className,
    children,
    disabled = false,
    label = "Filter",
    portalContainer,
}) => {
    const { open, close, isOpen } = useAggregatedFiltersContext();

    return (
        <span className={classNames(styles.filtersWrapper, className)}>
            <Popover
                open={isOpen}
                onOpenChange={(next) => {
                    if (disabled) {
                        close();
                        return;
                    }
                    if (next) {
                        open();
                    } else {
                        close();
                    }
                }}
            >
                <PopoverTrigger>
                    <Button
                        data-testid="add-agg-filter"
                        variant="primary"
                        size="md"
                        disabled={disabled}
                        leftIcon={<FilterIcon />}
                    >
                        {label}
                    </Button>
                </PopoverTrigger>

                <PopoverContent
                    align="start"
                    sideOffset={8}
                    className={styles.popover}
                    portalContainer={portalContainer}
                >
                    {children}
                </PopoverContent>
            </Popover>
        </span>
    );
};
